import { Module } from 'vuex-smart-module';
import WarrantyActions from './actions';
import WarrantyGetters from './getters';
import WarrantyMutations from './mutations';
import WarrantyState from './state';

export default new Module({
  state: WarrantyState,
  mutations: WarrantyMutations,
  actions: WarrantyActions,
  getters: WarrantyGetters,
});
